module.exports = __webpack_public_path__ + "img/erwei.4dd07cb5.png";